/**
 * "How saving works" — the design's rail panel, at the foot of the Library's
 * sidebar.
 *
 * The words are not new. They were the `title=` attribute on the line above the
 * grid, which is the worst place to keep an explanation: a tooltip is not there
 * when you go looking for it, it cannot be read at all on a phone, and nothing
 * on screen said it existed. Promoting them costs one panel and takes the
 * page's one piece of teaching out of hover-only.
 *
 * It is a SLOT the page fills, not a section `CategorySidebar` knows about
 * (`footer`) — that rail is shared with the decks page and the Bank, and
 * neither of those has anything to say about saving.
 */
export default function LibraryRailNote() {
  return (
    <section className="rail-note" aria-labelledby="rail-note-title">
      <h3 className="rail-note__title" id="rail-note-title">
        How saving works
      </h3>
      <p className="rail-note__body">
        An item is self-contained: one slide, or a series added to a deck as a group (a case study, a who-we-are
        sequence).
      </p>
      <p className="rail-note__body">
        Save new items from any deck: the slide's ⋮ menu, then "Save a copy to the RKH library". Tick several slides
        first and they are saved together as one series.
      </p>
      <p className="rail-note__body">
        File items into categories with Manage categories above, or an item's ⋮ → Move to category.
      </p>
    </section>
  );
}
